import {
  impactTypeLookup,
  pathogenicityLabelsLong,
  impactTypeLabels,
  pathogenicityIndex,
  pathogenicityFilters,
  impactCategories,
  impactIndex,
  impactLabels,
} from "../../constants/pathogenicity";
import Filter from "../../../../models/Filter";
import { ZYGOSITY_LABELS } from "../../constants/zygosity";
import { tierIndex, tierLabels } from "../../constants/ampTiers";

function getFilters(
  selectedColorBy,
  allSamples,
  colorByPathogenicity,
  colorByPhasingGroup,
  colorByImpact
) {
  const sampleFiltersAny = allSamples.map(
    (x) =>
      new Filter({
        category: "Variant In Any other Sample",
        key: `any-sample-${x.name}`,
        disableCategoryNum: true,
        label: `${x.name}`,
        nestId: `${x.name}-any`,
        isVisible: true,
      })
  );

  const sampleFiltersAll = allSamples.map(
    (x) =>
      new Filter({
        category: "Variant In All other Samples",
        key: `all-sample-${x.name}`,
        disableCategoryNum: true,
        label: `${x.name}`,
        nestId: `${x.name}-all`,
        isVisible: true,
      })
  );

  const sampleFiltersNot = allSamples.map(
    (x) =>
      new Filter({
        category: "Variant Not in Sample",
        key: `not-sample-${x.name}`,
        disableCategoryNum: true,
        label: `${x.name}`,
        nestId: `${x.name}-not`,
        isVisible: true,
      })
  );

  const pathoFilters = Array.from(
    new Set(Object.values(pathogenicityIndex))
      .filter((x) => pathogenicityFilters[x])
      .map(
        (x) =>
          new Filter({
            category: "Germline Classification",
            key: `pathogenicity-${x}`,
            label: pathogenicityLabelsLong[x],
          })
      )
      .values()
  );

  const coverageFilter = new Filter({
    label: "min coverage",
    key: "coverage",
    totalCount: null,
    isVisible: 1,
    value: 0,
    min: 0,
    max: 1000000000,
    type: "number",
  });

  const colorByPhase = new Filter({
    label: "Color By",
    key: "colorBy",
    isVisible: true,
    totalCount: 1,
    value: selectedColorBy,
    options: [colorByPathogenicity, colorByPhasingGroup, colorByImpact].map(
      (x) => ({
        key: x,
        label: x,
      })
    ),
    type: "select",
  });

  const ampFilters = Object.values(tierIndex).map((x) => {
    return new Filter({
      key: `amp-${x}`,
      value: 0,
      label: tierLabels[x],
      category: "Somatic Classification",
    });
  });

  const zygosityFilters = Object.keys(ZYGOSITY_LABELS).map((x) => {
    return new Filter({
      key: `zygosity-${x}`,
      value: 0,
      label: ZYGOSITY_LABELS[x],
      category: "Zygosity",
    });
  });

  const ciCat = "Coding Impact";

  const impactTypes = Object.keys(impactTypeLookup).map((x) => {
    return new Filter({
      key: `impact-${x}`,
      value: 0,
      label: impactTypeLabels[x],
      isVisible: true,
      category: "Coding Impact",
    });
  });

  const impactFilters = Object.keys(impactIndex)
    .map((x) => ({ ind: x, key: impactIndex[x] }))
    .map(({ key, ind }) => ({
      ind,
      key: `impact-${key}`,
      isVisible: true,
      label: impactLabels[key],
    }))
    .map((x) => ({ ...x, category: impactCategories[x.ind] || ciCat }))
    .map((x) => new Filter(x));

  return [
    ...ampFilters,
    ...pathoFilters,
    ...impactTypes,
    ...impactFilters,
    ...zygosityFilters,
    colorByPhase,
    ...sampleFiltersAny,
    ...sampleFiltersAll,
    ...sampleFiltersNot,
    coverageFilter,
  ];
}

export default getFilters;
